export default __webpack_public_path__ + "static/media/06.d4115d8d.svg";